import {
  getCurrentBrand,
  isDevAppEnv,
} from '@/shared/config/brand-by-target.mjs';

/**
 * Пути относительны везде, кроме лок. разработки — там дев-сервер крутится на localhost,
 * поэтому серверные пути резолвятся через поддомен {target}.stage.pingwin.fun.
 * Локальные ('/images') и уже абсолютные (http/https) пути не трогаем в любом окружении.
 */
const PASSTHROUGH_PREFIXES = ['images', '/images', 'http'] as const;

export function resolveMediaPath(path: string): string {
  const isPassthrough =
    !path ||
    !isDevAppEnv ||
    PASSTHROUGH_PREFIXES.some((prefix) => path.startsWith(prefix));

  if (isPassthrough) return path;

  return `https://${getCurrentBrand()}.stage.pingwin.fun/${path.replace(/^\//, '')}`;
}
